<template>
  <v-toolbar fixed color="primary" dark>
    <!-- App Title -->
    <v-app-bar-nav-icon
      @click="toogleSideNav"
      id="app_main_button"
    ></v-app-bar-nav-icon>
    <v-toolbar-title height="10">
      <router-link to="/" tag="span" style="cursor: pointer">
        <v-img
          max-width="90px"
          max-height="50px"
          :src="require('../../../public/og_logo.png')"
        />
        <!-- <v-img class="hidden-md-and-up"max-width="50px" max-height="50px" :src="require('../public/favicon.png')" /> -->
      </router-link>
    </v-toolbar-title>

    <!--v-select v-bind:items="clubs.edges" label="Select Club" item-value="node.clubId" item-text="node.clubName" hint="Reopen the page to select different club" v-model="club" @input="updateClubId(club)" style="cursor:pointer"
                >
                </v-select-->

    <v-spacer></v-spacer>
    <!--@input="updateClubId(club)"-->
    <!--
      v-text-field
      class="hidden-sm-only"
      flex
      prepend-icon="search"
      placeholder="Search Posts"
      color="accent"
      single-line
      hide-details
    >
    </v-text-field>
    <v-spacer></v-spacer-->
    <!--      <v-toolbar-items>-->
    <!--        <v-navigation-drawer-->
    <!--            v-model="sideNav"-->
    <!--            absolute-->
    <!--            temporary-->
    <!--            right-->
    <!--            height="100%"-->
    <!--        >-->
    <!--          <v-list-item>-->
    <!--            <v-list-item-avatar>-->
    <!--              <v-img src="https://randomuser.me/api/portraits/men/78.jpg"></v-img>-->
    <!--            </v-list-item-avatar>-->

    <!--            <v-list-item-content>-->
    <!--              <v-list-item-title>John Leider</v-list-item-title>-->
    <!--            </v-list-item-content>-->
    <!--          </v-list-item>-->

    <!--          <v-divider></v-divider>-->

    <!--          <v-list dense>-->
    <!--            <v-list-item>-->
    <!--              <v-list-item-icon>-->
    <!--                <v-icon>icon</v-icon>-->
    <!--              </v-list-item-icon>-->

    <!--              <v-list-item-content>-->
    <!--                <v-list-item-title>title</v-list-item-title>-->
    <!--              </v-list-item-content>-->
    <!--            </v-list-item>-->
    <!--          </v-list>-->
    <!--        </v-navigation-drawer>-->
    <!--      </v-toolbar-items>-->
    <!-- Horizontal Navbar Links -->
    <v-toolbar-items>
      <v-btn
        text
        v-for="item in horizontalNavItems"
        :key="item.title"
        :to="item.link"
        exact
        :id="'marketplace_' + item.title"
      >
        <v-icon left> {{ item.icon }}</v-icon>
        <span class="hidden-sm-and-down">
          {{ item.title }}
        </span>
      </v-btn>
      <!-- Cart Button -->

      <v-btn
        text
        @click="showCart"
        v-on:mouseenter="mouseOnCart"
        v-on:mouseleave="mouseLeaveFromCart"
        v-if="user"
        id="cart_btn"
      >
        <v-icon>shopping_cart</v-icon>
        <v-badge class="hidden-sm-and-down" right color="green">
          <!-- <span slot="badge">{{cart.length}}</span> -->
          <span slot="badge">{{ getCartQuantity }}</span>
          Cart
        </v-badge>
      </v-btn>

      <!-- Profile Button -->
      <v-btn
        text
        to="/auth/user_profile"
        v-if="user"
        id="marketplace_user_profile"
      >
        <v-icon>account_box</v-icon>
        <v-badge class="hidden-sm-and-down" right color="green">
          <span slot="badge">1</span>
          {{ user.userName }} | {{ user.role }}
        </v-badge>
      </v-btn>
      <!-- Signout Button -->
      <v-btn
        text
        @click="handleSignoutUser"
        v-if="user"
        id="marketplace_sign_out_horizontal"
      >
        <v-icon>exit_to_app</v-icon>
        <span class="hidden-sm-and-down"> Signout </span>
      </v-btn>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "HorizontalNavbar",
  data() {
    return {
      cartIsOpened: false
    };
  },
  computed: {
    ...mapGetters(["user", "cart"]),
    horizontalNavItems() {
      let items = [
        // { icon: "chat", title: "Posts", link: "/posts" },
        { icon: "lock_open", title: "Sign-In", link: "/auth/signin" },
        { icon: "create", title: "Sign-Up", link: "/auth/signup" }
      ];
      if (this.user) {
        items = [
          // { icon: "create", title: "TBD", link: "/signout" }
        ];
      }
      return items;
    },
    getCartQuantity() {
      return Object.values(this.cart).reduce(function(prev, cur) {
        return Number(prev) + Number(cur.quantity);
      }, 0);
    }
  },
  methods: {
    toogleSideNav() {
      this.$emit("toogleSideNav");
    },
    showCart() {
      this.$emit("showCart");
    },
    handleSignoutUser() {
      this.$store.dispatch("signoutUser");
    },
    mouseOnCart() {
      this.$emit("mouse-on-cart");
    },
    mouseLeaveFromCart() {
      this.$emit("mouse-leave-from-cart");
    }
  }
};
</script>
